import { render, staticRenderFns } from "./HelpIcon.vue?vue&type=template&id=39bee01c&scoped=true&"
import script from "./HelpIcon.vue?vue&type=script&lang=ts&"
export * from "./HelpIcon.vue?vue&type=script&lang=ts&"
import style0 from "./HelpIcon.vue?vue&type=style&index=0&id=39bee01c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bee01c",
  null
  
)

export default component.exports